<button class="button" (click)="startEmbeddedSignup($event)">
  <span class="material-symbols-outlined">chat</span>
  <span class="label">Start</span>
</button>
